module.exports = __webpack_public_path__ + "img/personhonor.139b4bcb.png";